import { Label, Switch } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function SwitchDemo() {
  return (
    <Section
      id="switch"
      title="Switch"
      description="On/off toggle. Use for binary state that takes effect immediately."
    >
      <VariantBlock label="Sizes">
        <div className="flex items-center gap-2">
          <Switch id="sw-default" defaultChecked />
          <Label htmlFor="sw-default">Default</Label>
        </div>
        <div className="flex items-center gap-2">
          <Switch id="sw-sm" size="sm" defaultChecked />
          <Label htmlFor="sw-sm">Small</Label>
        </div>
      </VariantBlock>

      <VariantBlock label="States">
        <div className="flex items-center gap-2">
          <Switch id="sw-off" />
          <Label htmlFor="sw-off">Off</Label>
        </div>
        <div className="flex items-center gap-2">
          <Switch id="sw-on" defaultChecked />
          <Label htmlFor="sw-on">On</Label>
        </div>
        <div className="flex items-center gap-2">
          <Switch id="sw-disabled" disabled />
          <Label htmlFor="sw-disabled">Disabled</Label>
        </div>
        <div className="flex items-center gap-2">
          <Switch id="sw-disabled-on" disabled defaultChecked />
          <Label htmlFor="sw-disabled-on">Disabled (on)</Label>
        </div>
      </VariantBlock>
    </Section>
  );
}
